<div class="comment" [class.first]="isFirst" [class.last]="isLast">
  <div class="header">
    <div class="avatar" [class.bordered]="!isExplorateurs">
      @if(!isExplorateurs) {
      <span>{{ avatar }}</span>
      } @else {
      <img loading="lazy" alt="logo" ngSrc="/footer/logo.svg" width="40" height="40" />
      }
    </div>
    <div class="info">
      <div class="name">
        {{ comment.name }}
      </div>
      <div class="date">
        {{ comment.date | date : 'dd MMMM yyyy' }}
      </div>
    </div>
    @if(!deviceService.isMobile()){
    <div class="link">
      <img loading="lazy" class="icon" alt="plus" ngSrc="/icons/plus.svg" width="12" height="12" />
      <a (click)="answerComment()">
        <ng-container>Répondre</ng-container>
        <div class="line"></div>
      </a>
    </div>
    }
  </div>
  <div class="text">
    {{ comment.text }}
  </div>
  <div class="container full-width">
    @if(deviceService.isMobile()){
    <div class="link">
      <img loading="lazy" class="icon" alt="plus" ngSrc="/icons/plus.svg" width="12" height="12" />
      <a (click)="answerComment()">
        <ng-container>Répondre</ng-container>
        <div class="line"></div>
      </a>
    </div>
    }
  </div>
  <div class="responses">
    @for(response of comment.commentResponses; track response.id) {
    <app-comment [comment]="response" (onAnswerComment)="answerComment(response)"> </app-comment>
    }
  </div>
</div>
